(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const targetKey = 'section_87UHeR';
    const sourceKey = 'section_iW4NVT';
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    let scheduled = false;

    const sectionByKey = (key) => document.querySelector(`[id*="${key}"]`);
    const wrapper = (section) => section?.querySelector(':scope .section-content-wrapper');

    const placeCards = () => {
      const targetSection = sectionByKey(targetKey);
      const sourceSection = sectionByKey(sourceKey);
      const targetWrap = wrapper(targetSection);
      const sourceWrap = wrapper(sourceSection);
      if (!targetWrap || !sourceWrap) return;

      if (mediaQuery.matches) {
        sourceWrap.querySelectorAll(':scope > .group-block').forEach((card) => {
          card.setAttribute('data-merged-category-card', '');
          targetWrap.append(card);
        });
        if (targetWrap.querySelector('[data-merged-category-card]')) {
          sourceSection.setAttribute('data-merged-into-scroll', '');
        }
        return;
      }

      targetWrap.querySelectorAll('[data-merged-category-card]').forEach((card) => {
        sourceWrap.append(card);
      });
      sourceSection.removeAttribute('data-merged-into-scroll');
    };

    const observe = () => {
      [targetKey, sourceKey].forEach((key) => {
        const wrap = wrapper(sectionByKey(key));
        if (!wrap || wrap.dataset.categoryMergeObserved) return;
        wrap.dataset.categoryMergeObserved = 'true';
        new MutationObserver(schedule).observe(wrap, { childList: true });
      });
    };

    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        placeCards();
        observe();
      });
    };

    mediaQuery.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule);
    } else {
      schedule();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
